jQuery_T4NT(document).ready(function ($) {
  /**
  *  Variant selection changed
  *  data-variant-toggle="{{ variant.id }}"
  */
  $(document).on("variant:changed", function (evt) {
  });
});
// Fix for quantity buttons on product pages and cart
document.body.addEventListener("click", function (e) {
  if (e.target.closest("[data-increase-qty]") || e.target.closest("[data-decrease-qty]")) {
    var btn = e.target.closest("button");

    var wrapper = btn.closest("[data-quantity-wrapper]");
    if (wrapper) {
      var input = wrapper.querySelector("[data-quantity-value]");
      if (input) {
        var currentVal = parseInt(input.value) || 1;
        var step = parseInt(input.getAttribute("step")) || 1;
        var min = parseInt(input.getAttribute("min")) || 1;
        var max = parseInt(input.getAttribute("max")) || 9999;
        var newVal = currentVal;

        if (btn.hasAttribute("data-increase-qty")) {
          if (currentVal + step <= max) {
            newVal = currentVal + step;
          }
        } else if (btn.hasAttribute("data-decrease-qty")) {
          if (currentVal - step >= min) {
            newVal = currentVal - step;
          }
        }

        if (newVal !== currentVal) {
          input.value = newVal;
          input.dispatchEvent(new window.Event("change", { bubbles: true }));
          input.dispatchEvent(new window.Event("input", { bubbles: true }));
          if (typeof jQuery_T4NT !== "undefined") {
            jQuery_T4NT(input).trigger("change");
          }

          // Update cart price when quantity changes in cart/mini-cart
          if (btn.closest('.t4s-cartPage__form') || btn.closest('.t4s-drawer') || btn.closest('.t4s-mini_cart')) {
            var lineItemKey = input.getAttribute("data-id");
            if (lineItemKey) {
              // Show loading state
              var cartWrapper = btn.closest('#t4s-mini_cart') || btn.closest('.t4s-cartPage__form');
              if (cartWrapper) {
                cartWrapper.classList.add('is--contentUpdate');
              }

              clearTimeout(window.cartReloadTimeout);
              window.cartReloadTimeout = setTimeout(function () {
                // Use Shopify's /cart/change.js API with the line item key and new quantity
                fetch((window.T4Sroutes && window.T4Sroutes.cart_change_url) || '/cart/change.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                  },
                  body: JSON.stringify({
                    id: lineItemKey,
                    quantity: newVal
                  })
                }).then(function (response) {
                  return response.json();
                }).then(function (cart) {
                  // Reload to reflect updated prices and quantities
                  window.location.reload();
                }).catch(function (err) {
                  console.error('Cart update failed:', err);
                  window.location.reload();
                });
              }, 400);
            }
          }
        }
      }
    }
  }

  // Fix for cart remove buttons
  var removeBtn = e.target.closest("[data-cart-remove]");
  if (removeBtn) {
    e.preventDefault();
    var lineItemKey = removeBtn.getAttribute("data-id");
    if (lineItemKey) {
      var cartWrapper = removeBtn.closest('#t4s-mini_cart') || removeBtn.closest('.t4s-cartPage__form') || removeBtn.closest('.t4s-drawer');
      if (cartWrapper) {
        cartWrapper.classList.add('is--contentUpdate');
      }

      fetch((window.T4Sroutes && window.T4Sroutes.cart_change_url) || '/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: lineItemKey,
          quantity: 0
        })
      }).then(function (response) {
        return response.json();
      }).then(function (cart) {
        window.location.reload();
      }).catch(function (err) {
        console.error('Cart remove failed:', err);
        window.location.reload();
      });
    }
  }

  // Fix for 'Click to enlarge' zoom button on product pages
  var zoomBtn = e.target.closest("[data-pr-trigger-pswp]");
  if (zoomBtn) {
    e.preventDefault();
    // Find the closest gallery wrapper
    var gallery = zoomBtn.closest("[data-t4s-gallery]") || document;
    // Get the currently selected slide image, or fallback to the first image
    var activeImageBtn = gallery.querySelector(".is-selected [data-t4s-gallery--open]") || gallery.querySelector("[data-t4s-gallery--open]");
    if (activeImageBtn) {
      activeImageBtn.click();
    }
  }
});

/**
 * ============================================================
 * iOS SAFARI / iPhone Drawer Fix
 * ============================================================
 *
 * Problem: On iOS Safari, the theme's drawer-open logic (data-drawer-open,
 * data-drawer-delay-, data-menu-drawer) relies on 'click' events dispatched
 * by the main theme.min.js. However:
 *
 * 1. iOS Safari has a historic 300ms tap delay on links with href attributes.
 *    While modern iOS 13+ has reduced this, it can still affect elements that
 *    don't have `touch-action: manipulation` set.
 *
 * 2. The mobile-performance.js defers loading of theme.min.js until user
 *    interaction. On the VERY FIRST tap on iOS, the script may not yet have
 *    attached its event listeners, so the drawer does nothing.
 *
 * 3. iOS Safari requires that click/tap handlers be on elements with an
 *    explicit event listener OR have cursor:pointer set — otherwise taps on
 *    non-anchor elements silently fail.
 *
 * Solution:
 * - Attach 'touchstart' listeners immediately (no defer) to all drawer-trigger
 *   elements using event delegation on document.
 * - On touchstart, immediately trigger the main theme's drawer open function
 *   if it exists, OR queue the open to retry once the theme JS is loaded.
 * - Prevent default on touchstart for cart/drawer links to eliminate the
 *   300ms delay and navigation fallback.
 */
(function () {
  'use strict';

  // Track whether we've moved significantly (to distinguish tap from scroll)
  var touchStartX = 0;
  var touchStartY = 0;
  var isTouchMove = false;

  document.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    isTouchMove = false;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    var dx = Math.abs(e.touches[0].clientX - touchStartX);
    var dy = Math.abs(e.touches[0].clientY - touchStartY);
    if (dx > 8 || dy > 8) {
      isTouchMove = true;
    }
  }, { passive: true });

  /**
   * Attempt to open a drawer by its CSS selector ID.
   * Tries the theme's built-in drawer API first, then falls back to
   * directly manipulating aria-hidden, which is how the drawers toggle.
   */
  function openDrawer(drawerId) {
    var drawer = document.querySelector(drawerId);
    if (!drawer) return;

    // Try the theme's global drawer open function (set by theme.min.js)
    if (window.T4S && typeof window.T4S.openDrawer === 'function') {
      window.T4S.openDrawer(drawerId);
      return;
    }

    // Fallback: directly trigger a click on an element that has the drawer-open
    // attribute pointing to this drawer (which the theme JS intercepts).
    // This works because the theme JS listens on 'click' via event delegation.
    var trigger = document.querySelector('[data-drawer-open][data-drawer-options*="' + drawerId.replace('#', '') + '"]') ||
                  document.querySelector('[data-drawer-options*="' + drawerId.replace('#', '') + '"]');
    if (trigger) {
      trigger.click();
      return;
    }

    // Last resort: directly toggle aria-hidden (same as what the theme JS does)
    var isHidden = drawer.getAttribute('aria-hidden') !== 'false';
    if (isHidden) {
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.remove('t4s-dn');
      // Add overlay
      var overlay = document.querySelector('.t4s-overlay') || createOverlay();
      if (overlay) {
        overlay.classList.add('is--visible');
        overlay.setAttribute('aria-hidden', 'false');
      }
      // Prevent body scroll
      document.documentElement.classList.add('t4s-drawer--is-open');
    }
  }

  function createOverlay() {
    var overlay = document.createElement('div');
    overlay.className = 't4s-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:468;display:none;';
    document.body.appendChild(overlay);
    overlay.addEventListener('click', function () {
      closeAllDrawers();
    });
    return overlay;
  }

  function closeAllDrawers() {
    document.querySelectorAll('.t4s-drawer[aria-hidden="false"]').forEach(function (d) {
      d.setAttribute('aria-hidden', 'true');
    });
    document.documentElement.classList.remove('t4s-drawer--is-open');
    var overlay = document.querySelector('.t4s-overlay');
    if (overlay) {
      overlay.classList.remove('is--visible');
      overlay.setAttribute('aria-hidden', 'true');
    }
  }

  /**
   * Core iOS fix: Handle touchend on drawer-trigger elements.
   * Using touchend (after touchstart+touchend without significant movement)
   * gives instant response with no 300ms delay.
   */
  document.addEventListener('touchend', function (e) {
    if (isTouchMove) return; // User was scrolling, not tapping

    var target = e.target;

    // ----- CART SIDEBAR -----
    // Handles: header cart icon, mobile toolbar cart button
    var cartTrigger = target.closest('[data-drawer-open][data-drawer-options*="t4s-mini_cart"]') ||
                      target.closest('[data-drawer-delay-][data-drawer-options*="t4s-mini_cart"]') ||
                      target.closest('a[href][data-drawer-options*="t4s-mini_cart"]');

    if (cartTrigger) {
      e.preventDefault();
      openDrawer('#t4s-mini_cart');
      return;
    }

    // ----- MENU DRAWER -----
    // Handles: hamburger menu button, mobile toolbar menu button
    var menuTrigger = target.closest('[data-menu-drawer]') ||
                      target.closest('[data-drawer-options*="t4s-menu-drawer"]');

    if (menuTrigger) {
      e.preventDefault();
      openDrawer('#t4s-menu-drawer');
      return;
    }

    // ----- LOGIN / REGISTER SIDEBAR -----
    // Handles: account icon in header, account button in mobile toolbar,
    //          login/register link in mobile menu
    var loginTrigger = target.closest('[data-drawer-delay-][data-drawer-options*="t4s-login-sidebar"]') ||
                       target.closest('[data-drawer-options*="t4s-login-sidebar"]') ||
                       target.closest('a[href][data-drawer-options*="t4s-login-sidebar"]');

    if (loginTrigger) {
      e.preventDefault();
      openDrawer('#t4s-login-sidebar');
      return;
    }

    // ----- SEARCH SIDEBAR -----
    var searchTrigger = target.closest('[data-drawer-delay-][data-drawer-options*="t4s-search-hidden"]') ||
                        target.closest('[data-drawer-options*="t4s-search-hidden"]');

    if (searchTrigger) {
      e.preventDefault();
      openDrawer('#t4s-search-hidden');
      return;
    }

    // ----- DRAWER CLOSE BUTTONS -----
    var closeBtn = target.closest('[data-drawer-close]') ||
                   target.closest('.t4s-drawer-menu__close') ||
                   target.closest('.t4s-drawer__close');

    if (closeBtn) {
      // Let the theme JS handle this via its own listener — but also ensure
      // it fires even if theme JS hasn't loaded yet
      var parentDrawer = closeBtn.closest('.t4s-drawer');
      if (parentDrawer) {
        parentDrawer.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('t4s-drawer--is-open');
      }
      return;
    }

  }, { passive: false });

  /**
   * Fix for iOS: When the theme JS uses 'data-drawer-delay-' attribute,
   * the theme may bind a 'click' listener. iOS sometimes doesn't fire click
   * on elements that aren't anchors/buttons. We force-register a click
   * listener fallback to ensure these fire on iOS too.
   *
   * This runs after DOM is ready to pick up all drawer-trigger elements.
   */
  function fixDrawerTriggers() {
    // Ensure all data-drawer-delay- elements fire click events on iOS
    var triggers = document.querySelectorAll('[data-drawer-delay-], [data-drawer-open], [data-menu-drawer]');
    triggers.forEach(function (el) {
      // Ensure cursor:pointer so iOS registers taps
      el.style.cursor = 'pointer';
      // Remove iOS tap highlight
      el.style.webkitTapHighlightColor = 'transparent';
      // Ensure touch-action doesn't block taps
      el.style.touchAction = 'manipulation';
    });
  }

  // Run immediately if DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixDrawerTriggers);
  } else {
    fixDrawerTriggers();
  }

  // Also run after theme JS loads (it may add more elements dynamically)
  document.addEventListener('scripts:lazyload', fixDrawerTriggers);

  // Run again after a short delay to catch dynamically added elements
  setTimeout(fixDrawerTriggers, 1000);
  setTimeout(fixDrawerTriggers, 3000);

})();

/**
 * ============================================================
 * Kwikpass iOS Safari Fix
 * ============================================================
 *
 * The Kwikpass login button in the mobile menu uses:
 *   <a href="javascript:void(0);" onclick="handleKpAndShopifyLogin();">
 *
 * On iOS Safari, `onclick` on `javascript:void(0)` links can fail silently
 * if the Kwikpass script hasn't fully initialized yet, OR if there's a 300ms
 * tap delay swallowing the event. This fix:
 *
 * 1. Intercepts touchend on #kplogin and #kpaccount items
 * 2. Directly calls the Kwikpass functions if available
 * 3. Falls back to the standard Shopify login URL if Kwikpass isn't ready
 */
(function () {
  'use strict';

  var kpTouchStartX = 0;
  var kpTouchStartY = 0;
  var kpTouchMoved = false;

  document.addEventListener('touchstart', function (e) {
    kpTouchStartX = e.touches[0].clientX;
    kpTouchStartY = e.touches[0].clientY;
    kpTouchMoved = false;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (Math.abs(e.touches[0].clientX - kpTouchStartX) > 8 ||
        Math.abs(e.touches[0].clientY - kpTouchStartY) > 8) {
      kpTouchMoved = true;
    }
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (kpTouchMoved) return;

    var target = e.target;

    // --- Kwikpass Login button (#kplogin) ---
    // Fires when user taps "Login / Register" in the mobile menu
    var kpLoginBtn = target.closest('#kplogin') ||
                     target.closest('[onclick*="handleKpAndShopifyLogin"]');

    if (kpLoginBtn) {
      e.preventDefault();
      if (typeof window.handleKpAndShopifyLogin === 'function') {
        // Kwikpass is ready — call it directly
        window.handleKpAndShopifyLogin();
      } else {
        // Kwikpass not loaded yet — fallback to Shopify login page
        // This ensures something always happens on iOS even if Kwikpass is slow
        window.location.href = '/account/login';
      }
      return;
    }

    // --- Kwikpass Account dropdown (#kpaccount sub-menu items) ---
    // Dashboard and Addresses links use kpHandleLogin()
    var kpDashboard = target.closest('[onclick*="kpHandleLogin"]');
    if (kpDashboard) {
      e.preventDefault();
      var onclickAttr = kpDashboard.getAttribute('onclick') || '';
      var match = onclickAttr.match(/kpHandleLogin\(['"]([^'"]+)['"]\)/);
      if (match && match[1]) {
        if (typeof window.kpHandleLogin === 'function') {
          window.kpHandleLogin(match[1]);
        } else {
          window.location.href = match[1];
        }
      }
      return;
    }

    // --- Kwikpass Logout ---
    var kpLogout = target.closest('[onclick*="handleLogout"]');
    if (kpLogout) {
      e.preventDefault();
      if (typeof window.handleLogout === 'function') {
        window.handleLogout();
      } else {
        window.location.href = '/account/logout';
      }
      return;
    }

  }, { passive: false });

  /**
   * Also ensure the Kwikpass elements have the right CSS for iOS taps.
   * This runs after DOM is ready.
   */
  function fixKwikpassElements() {
    var kpElements = document.querySelectorAll(
      '#kplogin, #kpaccount, #kplogin a, #kpaccount a, ' +
      '[onclick*="handleKpAndShopifyLogin"], [onclick*="kpHandleLogin"], [onclick*="handleLogout"]'
    );
    kpElements.forEach(function (el) {
      el.style.cursor = 'pointer';
      el.style.touchAction = 'manipulation';
      el.style.webkitTapHighlightColor = 'transparent';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixKwikpassElements);
  } else {
    fixKwikpassElements();
  }

  setTimeout(fixKwikpassElements, 500);
  setTimeout(fixKwikpassElements, 2000);

})();
